/**
 * Interface copy, as data. The API serves this bundle and the extension
 * bundles the same one as its fallback for before sign-in and offline
 * (D-33). Keys are stable identifiers; the English is the brief's approved
 * copy bank where a line exists there.
 *
 * Notification budget (brief 5.2): title about 40 characters carrying the
 * whole ask; body one line of about 60, optional reassurance; actions one
 * or two words, verb first.
 */
export const COPY_VERSION = "2026-10-26";

export const UI_COPY: Readonly<Record<string, string>> = {
  "notification.mobility.title": "Smart Break: two-minute mobility reset.",
  "notification.mobility.body": "Keep your back strong while you work.",
  "notification.walk.title": "Smart Break: a short walk.",
  "notification.walk.body": "A few minutes on your feet. Nothing is counting.",
  "notification.micro.title": "Thirty seconds to reset?",
  "notification.micro.body": "One easy movement, right at your desk.",
  "notification.reentry.title": "You've been heads-down for a while.",
  "notification.reentry.body": "Thirty seconds to reset?",
  "notification.action.start": "Start",
  "notification.action.quiet": "Quiet for 30 minutes",

  "dismiss.first": "No problem. The next one comes later today.",
  "dismiss.pause": "Pause today",
  "dismiss.nothingStacks": "Nothing stacks up. A dismissed prompt is gone, not waiting.",

  "completion.headline": "That counts.",
  "completion.stopped": "You started; stopping early is fine.",
  "feedback.prompt": "How does your back feel now?",
  "feedback.better": "Better",
  "feedback.same": "Same",
  "feedback.worse": "Worse",

  "focus.reentry": "Nothing stacked up while you were away.",
  "cap.reached": "That's your movement for today.",
  "walk.away": "Enjoy it. Nothing is counting.",
  "walk.return": "However long it was, it was a walk.",

  "panel.rest.moveNow": "Move now",
  "panel.rest.open": "Open my Back Coach",
  "panel.rest.nothingPlanned": "Nothing planned today.",
  "panel.rest.next": "Next one at",

  "firstRun.title": "Back Coach is set up for you.",
  "firstRun.body":
    "Your organisation has set up Back Coach, short movement breaks through the working day. Sign in with your work email to begin.",
  "firstRun.email": "Work email",
  "firstRun.code": "The six-digit code from your email",
  "firstRun.noOrg": "Back Coach has not been set up for your organisation yet.",

  "signin.email.title": "Sign in with your work email",
  "signin.email.body": "We'll email you a link. Open it on this computer and you're in. No password, nothing to remember.",
  "signin.email.cta": "Email me a link",
  "signin.sent.title": "Check your email",
  "signin.sent.body": "Open the link on this computer and you're in. We sent it to",
  "signin.sent.code": "Enter the code instead",
  "signin.code.body": "Type the six-digit code from the same email.",

  "popup.setup.title": "Two minutes to set up",
  "popup.setup.body": "A quick safety check and your Back Health Score, then breaks come to you.",
  "popup.setup.cta": "Set up now",
  "popup.today": "Today",
  "popup.pause": "Pause prompts for 30 minutes",
  "popup.link.progress": "Progress",
  "popup.link.workstation": "Workstation",
  "popup.link.settings": "Settings",
  "panel.idle.title": "No break running",
  "panel.idle.body": "Start one from the Back Coach icon in your toolbar.",
  "panel.close": "Close",

  "screening.v3.title": "Before you start",
  "screening.v3.intro": "Three quick questions. They check that gentle movement is right for you now, nothing more.",
  "screening.v3.confirm": "You answered yes to this. Is that right?",
  "screening.v3.confirmYes": "Yes, that's right",
  "screening.v3.confirmNo": "No, change it",
  "screening.v3.locked": "Thanks for telling us. This answer is now set.",
  "screening.v3.incomplete": "Please answer every question, and tick the box to start.",
  "screening.v3.held": "Back Coach is paused for now. Close this and see the note on your home screen.",
  "screening.private": "Nothing about your answers is shared with your employer.",
  "screening.urgent.title": "Please get this checked now",
  "screening.urgent.body":
    "These symptoms need checking urgently. Please call 999 or go to A&E now, and don't drive yourself. Back Coach is paused until you've been seen.",
  "screening.check.title": "Worth a quick check first",
  "screening.check.body":
    "Worth a quick check with your GP or a registered osteopath before you start. Once they've said gentle movement is fine, come back and we'll get you going.",
  "screening.hold.title": "Back Coach is paused",
  "screening.hold.returnFrom": "You can come back from",
  "screening.declare.action": "Continue",
  "screening.declared.body": "Thanks. Answer the safety questions again and your breaks will start.",
  "screening.rescreen.title": "Safety questions first",
  "screening.rescreen.body": "Please answer a few safety questions before your next break. It takes under a minute.",
  "screening.rescreen.action": "Answer the safety questions",
  "popup.hold.body": "Your breaks are on hold after your answers to the safety questions.",
  "popup.hold.cta": "See what happens next",
  "screening.intro": "Four quick questions first. They check that movement is right for you now, nothing more.",
  "screening.redflag.title": "Please get this checked soon",
  "screening.redflag.body":
    "A couple of the things you've described, changes to bladder or bowel control, numbness around the saddle area, or new leg weakness, should be assessed by a doctor promptly, ideally today. They're usually nothing serious, but they're not something to manage with a movement programme. Please contact your GP or call NHS 111. Back Coach will be here when you're ready.",
  "screening.redflag.action": "Contact my GP",
  "screening.flare.title": "Let's wait until the worst has passed",
  "screening.flare.body":
    "It sounds like you're in the middle of a flare-up right now. Back Coach is built for prevention and keeping a healthy back moving, and it works best once the acute phase has settled. Come back when you're moving more freely and we'll get you started. If your pain is severe or not improving, a GP or registered osteopath can help.",
  "screening.flare.action": "Remind me later",
  "screening.worsening.title": "Worth a check first",
  "screening.worsening.body":
    "Back pain that's steadily worsening week by week is worth having looked at before starting a movement programme, just to rule anything out. Please check in with your GP or a registered osteopath first. Back Coach will be here when you're ready.",
  "screening.worsening.action": "Find an osteopath",
  "screening.medical.title": "Check with your clinician first",
  "screening.medical.body":
    "Back Coach involves light mobility movement. If a doctor has advised you not to exercise, or you've had spinal surgery recently, please check with them before starting, they'll tell you when it's safe to begin.",
  "screening.medical.action": "I'll check first",

  "result.strong.label": "Green",
  "result.strong.body": "Your back is in a resilient place. Smart Breaks will help you stay there.",
  "result.active.label": "Amber",
  "result.active.body": "Your back is developing well overall. We'll help you protect it through your workday.",
  "result.foundation.label": "Red",
  "result.quote.who": "Every move counts towards better health.",
  "result.quote.who.by": "World Health Organisation",
  "result.quote.cmo": "Every minute counts.",
  "result.quote.cmo.body": "Regular activity can cut the risk of joint and back pain by up to 25%.",
  "result.quote.cmo.by": "UK Chief Medical Officers",
  "result.foundation.body": "Your back needs some support right now. We'll keep things light and build from there.",

  "reassessment.due": "Your quarterly Back Health Score is due.",
  "reassessment.snooze": "Remind me in a few days",

  "notify.test.title": "This is what a Back Coach prompt looks like.",
  "notify.test.body": "If you can read this, notifications reach you.",
  "notify.check.ask": "Send a test notification",
  "notify.check.question": "Did a notification appear just now?",
  "notify.check.yes": "Yes, I saw it",
  "notify.check.no": "No, nothing appeared",
  "notify.check.thanks": "Good. That is how every prompt will arrive.",
  "notify.silent.line": "Your last few prompts were sent but never seen. Notifications may be off for your browser in your system settings.",
  "notify.fix.mac": "On a Mac: System Settings, Notifications, find your browser and turn Allow notifications on. Check that a Focus is not on.",
  "notify.fix.windows": "On Windows: Settings, System, Notifications, find your browser and turn it on. Check that Focus assist is off.",
  "notify.fix.other": "Check your system's notification settings for this browser.",

  "dse.review.pending": "A competent person will look at this and advise you here.",
  "dse.review.nudge": "Worth raising with your manager. You can share a one-page summary.",
};
